import { getNotificationsAvailable } from '../../utils/getNotificationsAvailable'

type TUseIsPushGrantedParams = {
  enabled?: boolean
}

/** Sync on web; isPending is always false. */
// oxlint-disable-next-line hozana-local/use-prefix-for-hooks
export const useIsPushGranted = ({ enabled = true }: TUseIsPushGrantedParams = {}) => ({
  isPushGranted: enabled && getNotificationsAvailable() && Notification.permission === 'granted',
  isPending: false,
})
